export * from "-!../../../../node_modules/cache-loader/dist/cjs.js!../../../../node_modules/babel-loader/lib/index.js??ref--2-1!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./PageDivider.vue?vue&type=template&id=e2f84e14&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/PageDivider.vue?vue&type=template&id=e2f84e14&scoped=true
// module id = 188
// module chunks = 0